import { render, staticRenderFns } from "./PdpRaddar.vue?vue&type=template&id=b01e9e66&scoped=true&"
import script from "./PdpRaddar.vue?vue&type=script&lang=js&"
export * from "./PdpRaddar.vue?vue&type=script&lang=js&"
import style0 from "./PdpRaddar.vue?vue&type=style&index=0&id=b01e9e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01e9e66",
  null
  
)

export default component.exports